import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "programme-links padding-standard" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "show-programmes-button margin-r-half"
}
const _hoisted_4 = { key: 2 }

import { computed, ref } from "vue";

import { useOrganizationStore } from "@/stores/organization.store";
import { useProductsStore } from "@/stores/products.store";
import { useProgrammesStore } from "@/stores/programmes.store";

import { ProductItem } from "@/models/product.model";
import { Programme } from "@/models/programme.model";

import { getUnarchivedProducts } from "@/utils/filter-products-helpers";

interface DisplayProduct {
  name: string;
  id: number;
  products: ProductItem[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarPrograms',
  setup(__props) {

const orgStore = useOrganizationStore();
const programmesStore = useProgrammesStore();
const productsStore = useProductsStore();

const openProgrammes = ref<number[]>([]);

const productDetailsForDisplay = computed<ProductItem[]>(() => {
  if (!productsStore.productDetails) {
    return [];
  }
  return productsStore.productDetails.filter((product: ProductItem) => {
    return product.allocated_permissions.length > 0;
  });
});
const unarchivedProductDetailsForDisplay = computed<ProductItem[]>(() => {
  if (!productDetailsForDisplay.value.length) {
    return [];
  }
  return getUnarchivedProducts(productDetailsForDisplay.value);
});
const displayProducts = computed<DisplayProduct[]>(() => {
  if (!programmesStore.programmes) {
    return [];
  }
  return programmesStore.programmes.map((programme: Programme) => {
    const products: ProductItem[] =
      unarchivedProductDetailsForDisplay.value.filter(
        (e: ProductItem): boolean => e.programme_id === programme.programme_id
      );
    return {
      name: programme.name,
      id: programme.programme_id,
      products: products
    };
  });
});

const toggleProgramme = (id: number): void => {
  if (openProgrammes.value.includes(id)) {
    openProgrammes.value = openProgrammes.value.filter(
      (e: number): boolean => e !== id
    );
  } else {
    openProgrammes.value.push(id);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Programmes", -1)),
    _createElementVNode("ul", {
      class: _normalizeClass({
        'not-available': !_unref(orgStore).canOrgManageProgrammes,
        updating: _unref(programmesStore).areProgrammesUpdating
      })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayProducts.value, (programme) => {
        return (_openBlock(), _createElementBlock("li", {
          key: programme.id,
          class: "clearfix"
        }, [
          (programme.products.length > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: ($event: any) => (toggleProgramme(programme.id)),
                class: "btn-3 show-programmes-button margin-r-half"
              }, _toDisplayString(openProgrammes.value.includes(programme.id) ? "-" : "+"), 9, _hoisted_2))
            : _createCommentVNode("", true),
          (programme.products.length === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            class: "programme-link",
            to: `/programme/${programme.id}/products`,
            "data-testing": "sidebar-product-name"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(programme.name), 1)
            ]),
            _: 2
          }, 1032, ["to"]),
          (
            programme.products.length > 0 &&
            openProgrammes.value.includes(programme.id)
          )
            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(programme.products, (product) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "product-link",
                    key: product.id
                  }, [
                    _createElementVNode("small", null, [
                      _createVNode(_component_router_link, {
                        to: `/product/${product.id}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 2)
  ]))
}
}

})